import React from "react";
import { Link } from "react-router-dom";

const salesPanels = [
  {
    label: "How to get support for payment-related issues, referral queries, or new business inquiries?",
    content: [
      <>
        You can contact the sales team for payment-related issues, referral queries, or new business inquiries through the following channels:
        You can reach them by phone at <b className="phoneText">
          <a href="tel:+1(253)210-3860" style={{ textDecoration: "none", color: "black" }}>
            +1 (855) 230-0575
          </a>
        </b>, available from 9 AM to 6 PM PST.
        Alternatively, you can email them at{" "}
        <b> <Link to="mailto:sales@myliveeye.com" style={{ textDecoration: "none", color: "black" }}>
          sales@myliveeye.com
        </Link>.</b>
      </>
    ],
  }
];

const technicalSupportPanels = [
  {
    label: "How can I get technical support?",
    content: [
      <>
        For technical assistance, you can email{" "}
        <b> <Link to="mailto:support@myliveeye.com" style={{ textDecoration: "none", color: "black" }}>
          support@myliveeye.com
        </Link>{" "}</b>
        or call <b className="phoneText">
          <a href="tel:+18552300575" style={{ textDecoration: "none", color: "black" }}>
            +1(855)230-0575
          </a>
        </b>{" "}. Technical support is available from 8 AM to 6 PM PST.
      </>
    ],
  },
  {
    label: "What should I do if the system goes offline?",
    content: [
      <>
        Reboot the PoE switch and computer system to resolve the issue. If the issue persists, contact Technical Support team at{" "}
        <b className="phoneText">
          <a href="tel:+1(855)230-0575" style={{ textDecoration: "none", color: "black" }}>
            +1 (855) 230-0575
          </a>
        </b>{" "}
        or email at{" "}
        <b>
          <Link to="mailto:support@myliveeye.com" style={{ textDecoration: "none", color: "black" }}>
            support@myliveeye.com
          </Link>
        </b>.
      </>,
    ],
  },

  {
    label: "What should I do if the camera is disconnected?",
    content: ["Try rebooting the PoE switch and computer. If the problem continues, please contact the Technical Support team."],
  },
  {
    label: "What is the minimum upload speed required for IP cameras?",
    content: ["A minimum upload speed of 15 Mbps is recommended for efficient IP camera streaming."],
  }
];

const operationsPanels = [
  {
    label: "Is there 24/7 support available for operational queries?",
    content: [
      <>
        Yes, for operational issues, you can reach out 24/7 by phone at <b className="phoneText"><a href="tel:+1(253)220-7200" style={{ textDecoration: "none", color: "black" }}>
            +1 (855) 230-0575
          </a></b> or via email at{" "}
        <b>
          <Link to="mailto:help@myliveeye.com" style={{ textDecoration: "none", color: "black" }}>
            help@myliveeye.com
          </Link>
        </b>.
      </>
    ],
  },
  {
    label: "How to request video evidence?",
    content: [
      [
        "Go to the client queries page.",
        "Click on the create new query button.",
        "Fill in the required details in the form provided, including specific information about the video evidence needed. Submit the query.",
        "You can also track the status of your raised request easily on the client queries page."
      ],
    ]
  },
  {
    label: "How can I share video evidence?",
    content: [
      "When you play the video, click on the share button located at the bottom of the video player to share the video evidence via supported apps (e.g., Facebook, WhatsApp, email, Twitter, LinkedIn).",
    ],
  },
  {
    label: "How to check the suspicious transaction details?",
    content: [
      [
        "Go to the suspicious transaction alerts page.",
        "Use the search bar at the top of the page to search for the specific transaction.",
        "The relevant transactions will be displayed, along with detailed information such as the date, device, and video evidence related to that transaction.",
        "You can also track the status of your raised request easily using the client queries page."
      ],
    ]
  },
  {
    label: "What is the expected response time after pressing the trigger?",
    content: [
      "The expected response time is 20 seconds.",
    ],
  },
  {
    label: "Can I press the trigger again immediately after the first attempt?",
    content: [
      "No, please allow at least 20 seconds before trying again. Pressing the trigger multiple times in quick succession may result in delays in response.",
    ],
  },
  {
    label: "What to do if no response is received after pressing the trigger within 20 seconds?",
    content: [
      "If you do not receive any response within 20 seconds of pressing the trigger, please reach out immediately for assistance at (253) 220-7200. The support team is available 24/7 to address your concerns promptly.",
    ],
  },
  {
    label: "How to view reports for a specific time period?",
    content: [
      [
        "Go to the dashboard reports section.",
        "Find the date range selector at the top of the page.",
        "Choose your preferred time frame by selecting date ranges (e.g., last week, last month,custom date range) or using the custom date picker to set a specific start and end date. The reports will refresh automatically to display data for the selected time period.",
      ],
    ]
  },
  {
    label: "How to access cashier reports?",
    content: [
      [
        "Navigate to the cashier reports page directly.",
        "Alternatively, navigate to the reports section on the dashboard and choose cashier from the available options by selecting the radio button. The cashier-specific reports will be displayed based on your selection.",
      ],
    ]
  },
  {
    label: "How to approve/decline cashier reports?",
    content: [
      "When a cashier report is created, its status remains pending until the owner approves it. To approve the report:",
      [
        "Click on the specific cashier report.",
        "Scroll down to the bottom of the page, where you'll find the approve button.",
        "Click the approve button to update the status of the report.",
        "The report status can also be changed to declined. In such cases, please provide a reason for declining the report."
      ],
      "Please ensure you perform this action on a regular basis. It helps us verify that the status provided is accurate and gives us confidence in the correctness of the report."
    ],
  },
  {
    label: "How can I select a specific store to view reports and alerts?",
    content: [
      "At the top of the portal, there is a global store dropdown. By selecting a store from the dropdown menu, all corresponding reports, alerts, and queries for that store will be displayed. The content across all pages will be updated based on the selected store.",
    ],
  },
  {
    label: "Can I switch between stores easily?",
    content: [
      "Yes, you can switch between stores using the global store dropdown. Once you select a store, the information on all pages of the portal will update to show data for that store.",
    ],
  },
];

export { salesPanels, technicalSupportPanels, operationsPanels };  
